// Признак симулятора/эмулятора — только от платформы (@capacitor/device).
//
// Раньше в App.vue, AppHeader.vue, purchaseService и appReviewService симулятор
// искали по слову `Simulator` в navigator.userAgent. Ревью PR #433 сняло UA с живого
// iOS-симулятора (iPhone 16 Pro / iOS 18.2): слова там нет, проверка никогда не
// срабатывала, и все гейты «не на симуляторе» (StatusBar, пуши, RevenueCat, оценка
// в сторе) работали как на реальном устройстве.
//
// Ответ платформы за время жизни приложения не меняется, поэтому мост дёргается
// один раз: результат мемоизируется; отвергнутый промис из кэша убирается, чтобы
// следующий вызов мог повторить запрос.
//
// В вебе всегда false без обращения к плагину. При сбое плагина isVirtualDevice
// отвергается: решение «пропустить или продолжить» у каждого вызывающего своё (для
// необязательного диалога оценки безопаснее пропустить, для StatusBar и пушей —
// продолжить, как на реальном устройстве).

import { Capacitor } from "@capacitor/core";
import { Device } from "@capacitor/device";

// Фабрика с подменяемыми платформенными вызовами — для юнитов (мутация «все
// устройства виртуальные» выключала пуши, StatusBar, RevenueCat и оценку, и ни
// один тест этого не видел, ревью-3 PR #433).
export function createVirtualDeviceCheck({ isNativePlatform, getInfo }) {
  let cached = null;
  return function isVirtualDevice() {
    if (!isNativePlatform()) return Promise.resolve(false);
    if (!cached) {
      cached = Promise.resolve()
        .then(getInfo)
        .then((info) => Boolean(info) && info.isVirtual === true)
        .catch((error) => {
          cached = null;
          throw error;
        });
    }
    return cached;
  };
}

export const isVirtualDevice = createVirtualDeviceCheck({
  isNativePlatform: () => Capacitor.isNativePlatform(),
  getInfo: () => Device.getInfo(),
});

// Вариант для мест, где сбой плагина должен вести себя как реальное устройство:
// ошибка логируется, результат — false.
export async function isVirtualDeviceOrFalse(label = "isVirtualDevice", check = isVirtualDevice) {
  try {
    return await check();
  } catch (error) {
    console.warn(`${label}: Device.getInfo failed, treating as real device`, error);
    return false;
  }
}
